import { Routes } from 'config/routes';
import { UserRole } from 'gql/types';
import { RouteType } from 'modules/auth/enums';
import { IModule } from 'modules/common/interfaces';

import SettingsPage from './pages/Settings';

const ALL_INTERNAL_ROLES = [
  UserRole.Admin,
  UserRole.MedicalDirector,
  UserRole.Dvm,
  UserRole.CanineHandler,
  UserRole.TeamLead,
  UserRole.Operations,
  UserRole.RegionalUser,
  UserRole.Phlebotomist,
];

const settingsModule: IModule = {
  routes: [
    {
      path: Routes.Settings,
      Component: SettingsPage,
      type: RouteType.Auth,
      roles: ALL_INTERNAL_ROLES,
    },
    {
      path: Routes.SettingsNotifications,
      Component: SettingsPage,
      type: RouteType.Auth,
      roles: ALL_INTERNAL_ROLES,
    },
    {
      path: Routes.SettingsGeneral,
      Component: SettingsPage,
      type: RouteType.Auth,
      roles: [UserRole.Admin],
    },
    {
      path: Routes.SettingsDonors,
      Component: SettingsPage,
      type: RouteType.Auth,
      roles: [UserRole.Admin],
    },
    {
      path: Routes.SettingsPhlebotomistDashboard,
      Component: SettingsPage,
      type: RouteType.Auth,
      roles: [UserRole.Admin],
    },
    {
      path: Routes.SettingsRecruiterDashboard,
      Component: SettingsPage,
      type: RouteType.Auth,
      roles: [UserRole.Admin],
    },
    {
      path: Routes.SettingsOpsDashboard,
      Component: SettingsPage,
      type: RouteType.Auth,
      roles: [UserRole.Admin],
    },
    {
      path: Routes.SettingsHandlerDashboard,
      Component: SettingsPage,
      type: RouteType.Auth,
      roles: [UserRole.Admin],
    },
    {
      path: Routes.SettingsNightlyCounts,
      Component: SettingsPage,
      type: RouteType.Auth,
      roles: [UserRole.Admin, UserRole.MedicalDirector, UserRole.Operations],
    },
  ],
};

export default settingsModule;
